module.exports = __webpack_public_path__ + "static/header_mobile_4-cdde66ef2394e7285dc2f7f6750ef239.jpg";